export default __webpack_public_path__ + "static/media/origami_bg.df471ced.mp4";